import type {
    NormalizedDefaultSectionEntity,
    NormalizedSectionEntity,
    NormalizedSpecificSectionEntity,
    NormalizedZeroSectionEntity,
} from '@web/types';

import { createSection } from '@sites/entity-core';

import { getUuid } from '@common/helpers';
import { TRANSPARENT_VALUE } from '@components/sp-color-picker/src/constants/color-picker-presets.const';

type SectionSeed = Partial<Pick<NormalizedSectionEntity, 'parentId' | 'children'>>;

/**
 * Seeds come from `@sites/entity-core` so the store and the schema the entity
 * is validated against cannot drift apart — only identity, the parent link and
 * the column list are filled in here.
 */
export const sectionInstance = ({ parentId, children = [] }: SectionSeed = {}): NormalizedDefaultSectionEntity => ({
    ...createSection('default'),
    id: getUuid(),
    parentId,
    children,
});

export const specificSectionInstance = ({
    parentId,
    children = [],
}: SectionSeed = {}): NormalizedSpecificSectionEntity => ({
    ...createSection('specific', { transparentColor: TRANSPARENT_VALUE }),
    id: getUuid(),
    parentId,
    children,
});

export const zeroSectionInstance = ({ parentId, children = [] }: SectionSeed = {}): NormalizedZeroSectionEntity => ({
    ...createSection('zero'),
    id: getUuid(),
    parentId,
    children,
});
